export class BalanceFormatterUtil {
  static getFormattedBalance(balance: number | undefined): string {
    if (balance === undefined) {
      return '';
    }
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(balance);
  }
}
